
class NoiseCordinates {
  freq: number;
  power: number;
}

export class NoiseData {
  username: string; // Here for model uniformity. necessary for referenceSweep.
  timestamp: number;
  latitude: number;
  longitude: number;
  live: NoiseCordinates[];
  min: NoiseCordinates[];
  max: NoiseCordinates[];
  percentile: NoiseCordinates[];
  agcLevel: number;
  heatmap: Heatmap[];

  constructor(
    httpResponse: NoiseData
  ) {
    // @ts-ignore
    this.username = httpResponse['userId']; // The backend changes from username to userId a lot. We don't stand for that sort of funny business on the front end.
    this.timestamp = httpResponse.timestamp;
    this.latitude = httpResponse.latitude;
    this.longitude = httpResponse.longitude;
    this.live = httpResponse.live;
    this.min = httpResponse.min;
    this.max = httpResponse.max;
    this.percentile = httpResponse.percentile;
    this.agcLevel = httpResponse.agcLevel;
    this.heatmap = httpResponse.heatmap;
  }
}
export interface Heatmap {
  frequencyKHz: number;
  heatPairs: HeatPairsEntity[];
}
export interface HeatPairsEntity {
  db: number;
  count: number;
}
